import { DeviceInfo } from '@capacitor/core';

export class SetDeviceToken {
    public static readonly type = '[RootState] Set device token';

    constructor(public deviceToken: string, public deviceType: DeviceInfo['platform']) {}
}
